import Swiper from '../vendor/swiper.js';

// slider partners top
let partnersSliderTop = new Swiper('.partners__slider-top', {
  observer: true,
  observeParents: true,
  spaceBetween: 30,
  slidesPerView: 'auto',
  speed: 8000,
  loop: true,
  autoplay: {
    delay: 0,
  },
});

// slider partners bot
let partnersSliderBot = new Swiper('.partners__slider-bot', {
  observer: true,
  observeParents: true,
  spaceBetween: 30,
  slidesPerView: 'auto',
  speed: 8000,
  loop: true,
  autoplay: {
    delay: 0,
  },
});

let reviewsSlider = new Swiper('.reviews__slider', {
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination",
    type: 'bullets',
    clickable: true,
  },
  
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 30,
    }
  },
});











